// @components
import TextField from "components/fields/text";
import SwitchField from "components/fields/switch";
import RadioImageField from "components/fields/radio-image";
import DateMaskField from "components/fields/date-mask";
import SelectField from "components/fields/select";
import RadioText from "components/fields/radio-text";
import RadioButton from "components/fields/radio-button";
import Recaptcha from "components/fields/recaptcha";
import ButtonField from "components/fields/button-field";
import CheckboxField from "components/fields/checkbox";
import SpaceField from "components/fields/space";
import ReadOnlyField from "components/fields/readonly";
import DatePickerComponent from "components/fields/datepicker";
import ProgressBar from "components/fields/progress";
import BigSwitch from "components/fields/big-switch";
import TextMaskField from "components/fields/text-mask";
import InsuredCards from "components/fields/insured-cards";
import BasicCard from "components/fields/basic-card";
import InsuredInfo from "components/fields/insured-info";
import BigCheckboxField from "components/fields/big-checkbox";

export const fields = (type, data, form, key, currentQuestion) => {
  switch (type) {
    case 'textfield':
      return <TextField info={data} form={form} key={key} current={currentQuestion} />;
    case 'textMask':
      return <TextMaskField info={data} key={key} form={form} current={currentQuestion} />;
    case 'checkbox':
      return <SwitchField info={data} key={key} form={form} current={currentQuestion} />
    case 'checkClassic':
      return <CheckboxField info={data} key={key} form={form} current={currentQuestion} />
    case 'radioImage':
      return <RadioImageField info={data} key={key} form={form} current={currentQuestion} />
    case 'radioText':
      return <RadioText info={data} key={key} form={form} current={currentQuestion} />
    case 'radioButton':
      return <RadioButton info={data} key={key} form={form} current={currentQuestion} />
    case 'datetime':
      return <DateMaskField info={data} key={key} form={form} current={currentQuestion} />
    case 'select':
      return <SelectField info={data} key={key} form={form} current={currentQuestion} />
    case 'recaptcha':
      return <Recaptcha info={data} form={form} key={key} />
    case 'button':
      return <ButtonField info={data} form={form} current={currentQuestion} />
    case 'bigSwitch':
      return <BigSwitch info={data} />
    case 'readonly':
      return <ReadOnlyField info={data} />
    case 'fakeField':
      return <SpaceField />
    case 'datePicker':
      return <DatePickerComponent info={data} form={form} key={key} current={currentQuestion} />
    case 'numberSlide':
      return <ProgressBar info={data} form={form} key={key} current={currentQuestion} />
    case 'basicCard':
      return <BasicCard info={data} form={form} key={key} current={currentQuestion} />
    case 'insuredCards':
      return <InsuredCards info={data} form={form} key={key} current={currentQuestion} />
    case 'InsuredInfo':
      return <InsuredInfo info={data} form={form} key={key} current={currentQuestion} />
    case 'BigCheckboxField':
      return <BigCheckboxField info={data} key={key} />
    default:
      return null;
  }
}